import {Component, ViewEncapsulation} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {AuthService} from '../../_services';
import {Router} from '@angular/router';
import {SpinnerService} from '../../_components/spinner/spinner.service';
import {Constants} from '../../_utility';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule],
})
export class LoginComponent {

  wrongInput: boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private spinner: SpinnerService
  ) {
  }

  signIn() {
    this.spinner.show();
    this.auth.SignIn()
      .then((result) => {
        if(result?.user)
          return result.user.getIdToken();
        else // Go to catch error
          throw new Error("Token non presente");
      })
      .then((result2) => {
          this.spinner.hide();
          this.getInfoUser(result2);
      }).catch(err => {
        console.log(err);
        this.spinner.hide();
        this.wrongInput = true;
    });
  }

  async getInfoUser(idToken: string){
    this.spinner.show();

    this.auth.login(idToken).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.auth.setUserInfo(res,idToken);
        this.router.navigate(Constants.Routing.HOME.routerLink);
      },
      error: (err) => {
        console.log(err);
        this.spinner.hide();
        this.wrongInput = true;
      },
    });
  }

}
